import { render, staticRenderFns } from "./AtualizarFila.vue?vue&type=template&id=01bc8eed&"
import script from "./AtualizarFila.vue?vue&type=script&lang=js&"
export * from "./AtualizarFila.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports